import { render, staticRenderFns } from "./block-newsletter-push.vue?vue&type=template&id=2da78252&scoped=true&"
import script from "./block-newsletter-push.vue?vue&type=script&lang=js&"
export * from "./block-newsletter-push.vue?vue&type=script&lang=js&"
import style0 from "./block-newsletter-push.vue?vue&type=style&index=0&id=2da78252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da78252",
  null
  
)

export default component.exports